import { ENV_CONFIG } from '../consts';

export default (env, region, key) => {
  if (ENV_CONFIG[region] && ENV_CONFIG[region][env] && ENV_CONFIG[region][env][key]) {
    return ENV_CONFIG[region][env][key];
  } else {
    throw new Error(`Cannot find env config for env: ${env}, region: ${region} and key: ${key}`);
  }
};
